/**
 * 3D渲染模式：将渲染过程中的中间结果输出，主要用于排查渲染效果问题，支持 pbr 和 unlit 材质
 */
export var RenderMode3D;
(function (RenderMode3D) {
    /**
     * 正常渲染
     */
    RenderMode3D["none"] = "none";
    /**
     * 纹理坐标
     */
    RenderMode3D["uv"] = "uv";
    /**
     * 世界坐标法线
     */
    RenderMode3D["normal"] = "normal";
    /**
     * 基础颜色
     */
    RenderMode3D["basecolor"] = "basecolor";
    /**
     * 基础颜色 Alpha
     */
    RenderMode3D["alpha"] = "alpha";
    /**
     * 金属度
     */
    RenderMode3D["metallic"] = "metallic";
    /**
     * 粗超度
     */
    RenderMode3D["roughness"] = "roughness";
    /**
     * 环境遮蔽
     */
    RenderMode3D["ao"] = "ao";
    /**
     * 自发光
     */
    RenderMode3D["emissive"] = "emissive";
    /**
     * 漫反射
     */
    RenderMode3D["diffuse"] = "diffuse";
})(RenderMode3D || (RenderMode3D = {}));
